
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.692 11.866L7.443 7.205a.931.931 0 01.292-.946l5.594-4.823a.931.931 0 011.507.465l2.92 10.895a.931.931 0 01-1.077 1.155L9.414 12.54a.931.931 0 01-.722-.673zM3.218 8.397a.931.931 0 00-.659 1.14l.067.248c-.568.152-.89.79-.721 1.423.17.633.768 1.024 1.335.872l.067.248a.931.931 0 001.14.658l2.313-.62a.931.931 0 00.659-1.14l-.748-2.79a.931.931 0 00-1.14-.66l-2.313.62zM5.124 14.998a.931.931 0 01.659-1.14l1.285-.345a.931.931 0 011.14.659l.748 2.79a.931.931 0 01-.659 1.14l-1.285.345a.931.931 0 01-1.14-.658l-.748-2.79z","fill":"currentColor"}})])
          )
        }
      }
    